import type { TenantPublico, UsuarioSesion } from './sesion'

// La sesión de un local abierta por alguien de PLATAFORMA.
//
// Vive en su propio módulo y no dentro de `plataforma.ts` ni de `sesion.ts`
// porque los dos la necesitan: el panel la escribe al entrar y la sesión del
// local la lee al rehidratar. Con el helper adentro de uno de los dos, los
// módulos se importan en círculo.
//
// sessionStorage: la intervención es de esta pestaña y muere con ella. Y
// sobrevive a un F5, que en una sesión SIN refresh token es lo único que
// permite recargar sin quedarse afuera.
const CLAVE = 'fruver.suplantada'

export interface SesionSuplantada {
  accessToken: string
  expiraAt: string
  tenantSlug: string
  tenantNombre: string

  /** Como qué usuario del local se entró. */
  comoUsuario: string

  /** Con la misma forma que el login, para aplicarla por el camino de siempre. */
  usuario: UsuarioSesion
  tenant: TenantPublico
}

export function guardarSuplantada(s: SesionSuplantada) {
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify(s))
  } catch {
    // Sin almacenamiento la sesión igual funciona en memoria: lo que se
    // pierde es sobrevivir a un F5, no la intervención.
  }
}

/** La sesión suplantada de esta pestaña, si hay una y todavía vale. */
export function sesionSuplantada(): SesionSuplantada | null {
  try {
    const crudo = sessionStorage.getItem(CLAVE)
    if (!crudo) return null

    const s = JSON.parse(crudo) as SesionSuplantada

    // Se valida la FORMA, no solo que haya algo guardado.
    //
    // Lo que hay acá lo escribió una versión anterior del bundle, y el bundle
    // se actualiza por OTA: un registro viejo al que le falte un campo hace
    // que la rehidratación explote al leer `tenant.zonaHoraria` y el SPA no
    // arranca —pantalla en blanco, en la caja del mostrador—. Ante la duda se
    // descarta y se pide entrar de nuevo, que es una molestia y no una falla.
    const completa =
      typeof s?.accessToken === 'string' &&
      s.accessToken.length > 0 &&
      typeof s.expiraAt === 'string' &&
      typeof s.tenantSlug === 'string' &&
      typeof s.usuario?.id === 'number' &&
      Array.isArray(s.usuario.permisos) &&
      typeof s.tenant?.zonaHoraria === 'string'

    // Un token vencido se olvida acá y no se usa: el pedido daría 401 y la
    // pantalla mostraría un error donde corresponde volver al panel.
    if (!completa || new Date(s.expiraAt).getTime() <= Date.now()) {
      sessionStorage.removeItem(CLAVE)
      return null
    }

    return s
  } catch {
    return null
  }
}

export function olvidarSuplantada() {
  try {
    sessionStorage.removeItem(CLAVE)
  } catch {
    /* nada que hacer */
  }
}
